import React, { PropsWithChildren, useImperativeHandle, useState } from 'react';
import { Form, FormProps, FormResetParams } from 'tdesign-react';

import RegistrationForm from './formRender';
import type { ICustomConfig, IFormItemProps, IFormValue, IRenderType } from './interface';

const FormComponent: React.FC<PropsWithChildren<{
  cRef?: any;
  pageId?: string;
  className?: string;
  formConfig?: FormProps;
  fieldsConfig: IFormItemProps[];
  formData?: IFormValue;
  customRender?: { [key: string]: IRenderType };
  customConfig?: ICustomConfig;
  isDraft?: boolean;
  repeatConfig?: { [key: string]: IFormItemProps[] };
  onSubmit?: (values: any) => void;
  onSubmitFail?: (result: any) => void;
  refactorFieldsConfig?: (configs: IFormItemProps[]) => IFormItemProps[];
}>
> = (props) => {
  const [form] = Form.useForm();
  const [errors, setErrors] = useState({});

  useImperativeHandle(props.cRef, () => ({
    form,
    handleSubmit: () => {
      form.submit?.();
    },
    handleReset: (params: FormResetParams<IFormValue>) => {
      form.reset?.(params);
    },
  }));

  const { formConfig = {} } = props;
  // const fieldsConfig = props.fieldsConfig.filter(item => item.render !== 'hidden');
  const [initFormData] = useState<any>(() => {
    const data: any = {};
    props.fieldsConfig.forEach((item: any) => {
      data[item.props] = item.defaultValue || item.uiOptions?.defaultValue;
    });
    return { ...data, ...props.formData };
  });

  const forceUpdate: () => void = useState({})[1].bind(null, {});

  const handleSubmit = (result: any) => {
    if (result.validateResult === true) {
      const values = form.getFieldsValue?.(true);
      const hideValue: any = {};
      props.fieldsConfig
        .filter(item => item.render === 'hidden')
        .forEach((item) => {
          hideValue[item.props] = initFormData[item.props];
        });
      props.fieldsConfig
        .filter(item => item.render === 'divider')
        .forEach((item) => {
          delete values[item.props];
        });
      const tmpValues = {
        ...values,
        ...hideValue,
      };
      const fieldKeys = props.fieldsConfig.map(item => item.props);
      Object.keys(tmpValues).forEach((key) => {
        if (!fieldKeys.includes(key)) {
          delete tmpValues[key];
        }
      });
      props.onSubmit?.(tmpValues);
    }
    props.onSubmitFail?.(result.validateResult);

    if (result.validateResult !== true) {
      setErrors(result.validateResult);
    }
    forceUpdate();
  };

  const onValuesChange = (context: Record<string, unknown>, allValues: Record<string, unknown>) => {
    // form.clearValidate?.();
    const tmpValues = context;
    const fieldKeys = props.fieldsConfig.map(item => item.props);
    Object.keys(tmpValues).forEach((key) => {
      if (!fieldKeys.includes(key)) {
        delete tmpValues[key];
      }
    });
    formConfig.onValuesChange?.(tmpValues, allValues);
    setErrors({});
    forceUpdate();
  };

  const getFieldsConfig = () => {
    const result = props?.refactorFieldsConfig?.(props.fieldsConfig) || props.fieldsConfig;
    return result?.map(e => ({ ...e, uiOptions: { ...e?.uiOptions, errors } }));
  };

  return (
    <Form
      className={`custom-form ${props.className}`}
      form={form}
      onSubmit={handleSubmit}
      initialData={initFormData}
      {...formConfig}
      onValuesChange={onValuesChange}
    >
      <RegistrationForm
        form={form}
        pageId={props.pageId}
        repeatConfig={props.repeatConfig}
        initFormData={initFormData}
        formData={props.formData}
        fieldsConfig={getFieldsConfig()}
        {...props.customConfig}
        customRender={props.customRender}
      ></RegistrationForm>
      {props.children}
    </Form>
  );
};

export default FormComponent;
